import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";
import React from "react";
import { Input } from "semantic-ui-react";
import moment from "moment-timezone";

interface DateTimePickerProps {
  selectedDate?: Date | undefined;
  selectedTime?: Date | undefined;
  minDate?: Date | undefined;
  maxDate?: Date | undefined;
  editable?: boolean;
  onChangeDate?: (date: Date) => void;
  onChangeTime?: (date: Date | undefined) => void;
  dateOnly?: boolean;
  timeOnly?: boolean;
}

type Props = DateTimePickerProps;

export const DateTimePicker: React.FC<Props> = ({
  selectedDate,
  selectedTime,
  minDate,
  maxDate,
  editable = true,
  onChangeDate,
  onChangeTime,
  dateOnly,
  timeOnly,
}) => {
  const isMinDate = (date: Date | undefined) => {
    return date && minDate && moment(date).isSame(minDate, "day");
  };

  const isValidTime = (time: string | number | Date) => {
    if (isMinDate(selectedDate)) {
      return moment(time).isAfter(minDate);
    }
    return true;
  };

  const timeZoneCode = moment.tz(moment.tz.guess()).zoneAbbr();

  return (
    <div className={"dateTimePicker"}>
      {!timeOnly && (
        <DatePicker
          customInput={<Input icon="calendar alternate outline" className={"datePickerInput"} />}
          data-elm-id={"postInputSelectedDate"}
          id={"date-selector"}
          name={"date-selector"}
          selected={selectedDate}
          onChange={(date: any) => {
            if (date && onChangeDate) {
              onChangeDate(date);
              if (onChangeTime && isMinDate(date) && selectedTime && moment(selectedTime).isBefore(minDate)) {
                onChangeTime(undefined);
              }
            }
          }}
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={15}
          maxDate={maxDate}
          minDate={minDate}
          dateFormat="EE, MM/dd/yyyy"
          disabled={!editable}
          autoComplete={"off"}
          placeholderText={"Date"}
        />
      )}
      {!dateOnly && (
        <div className={"timePickerContainer"}>
          <DatePicker
            customInput={
              <Input
                className={"timePickerInput"}
                label={{ basic: true, content: timeZoneCode }}
                labelPosition="right"
              />
            }
            data-elm-id={"postInputSelectedTime"}
            id={"time-selector"}
            name={"time-selector"}
            selected={selectedTime}
            onChange={(date: any) => {
              if (date && onChangeTime) {
                onChangeTime(date);
              }
            }}
            showTimeSelect
            showTimeSelectOnly
            filterTime={isValidTime}
            dateFormat="h:mm aa"
            autoComplete={"off"}
            disabled={!editable}
            placeholderText={"Time"}
            className={"timePicker"}
          />
        </div>
      )}
    </div>
  );
};
